module.exports = __webpack_public_path__ + "web/img/png.398c4bac.png";